import { Routes } from '@angular/router';
import { ScreenComponent } from './screen.component';
import { RoutingConfig } from '@app/routing/routing.config';

export const ScreenRoutes: Routes = [
  { 
    path: '', 
    component: ScreenComponent,
    children: [
      {
        path: RoutingConfig.PageErrors,
        loadChildren: () => import('@app/modules/errors-modules/client/errors.module').then((m) => m.ErrorsModule)
      },
      {
        path: RoutingConfig.Login,
        loadChildren: () => import('@app/modules/auth-modules/client/auth.module').then((m) => m.AuthModule)
      }
    ]
  }
];
